/* global mockWPData */
const { categorization = {}, options = {} } = mockWPData || {};
/* eslint-disable quote-props */
const defaultState = {
  table: {},
  data: {
    ...categorization,
    options,
    print: false,
  },
  router: {
    view: '0',
  },
};

export default defaultState;



// WEBPACK FOOTER //
// ./app/config/defaultState.js